export default __webpack_public_path__ + "static/media/portfolio_katif.87b2534c.png";